import { clsx } from "clsx";
import type { ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    // Mirrors the custom `spacing` scale in tailwind.config.js. Without
    // this, tailwind-merge treats e.g. `px-appkit-sm` as an unknown class
    // and keeps it alongside a later `px-0` override — and since
    // `.px-appkit-sm` sorts after `.px-0` in the generated CSS, the override
    // silently loses. That collapsed icon-only buttons to zero content width
    // (26px box minus 2×12px padding minus border).
    theme: {
      // Mirrors the custom `borderRadius` scale in tailwind.config.js.
      radius: [
        "glass",
        "panel",
        "menu",
        "progress",
        "frame",
        "toolbar",
        "chrome",
        "input",
        "rail",
        "control-sm",
        "control",
        "preview",
        "pill",
        "card",
      ],
      spacing: [
        "appkit-2xs",
        "appkit-xs",
        "appkit-sm",
        "appkit-md",
        "appkit-lg",
        "appkit-xl",
        "appkit-2xl",
        "appkit-3xl",
        "appkit-control-icon",
      ],
    },
    classGroups: {
      "font-size": [
        "text-canvas-2xs",
        "text-canvas-xs",
        "text-canvas-sm",
        "text-canvas-base",
        "text-canvas-md",
        "text-canvas-lg",
        "text-canvas-xl",
        "text-appkit-mini",
        "text-appkit-small",
        "text-appkit-caption",
        "text-appkit-body",
        "text-appkit-subhead",
        "text-appkit-title",
        "text-appkit-headline",
        "text-appkit-large-title",
        "text-appkit-display",
      ],
    },
  },
});

/**
 * Merge Tailwind classes with proper conflict resolution.
 * Combines clsx (conditional classes) with tailwind-merge (deduplication).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
